import { useEffect } from 'react';
import NProgress from 'nprogress';
import { Box, CircularProgress, alpha } from '@mui/material';

function SuspenseLoader() {
  useEffect(() => {
    NProgress.start();

    return () => {
      NProgress.done();
    };
  }, []);

  return (
    <Box
      sx={{
        position: 'fixed',
        left: 0,
        top: 0,
        width: '100%',
        height: '100%',
        background: (theme) => alpha(theme.palette.background.default, 0.6),
        backdropFilter: 'blur(2px)',
        zIndex: 1300
      }}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress
        size={48}
        disableShrink
        thickness={3.5}
        sx={{ color: (theme) => theme.colors.primary.main }}
      />
    </Box>
  );
}

export default SuspenseLoader;
